module.exports = __webpack_public_path__ + "static/media/bares-notables-de-buenos-aires.b2e5e94f.md";